import {
  GetCustomDataList,
  SaveOrUpdateCustomData,
} from "@/axios/IScene.js";
import {
  saveFeifanPoint
} from '@/axios/IDevice.js'
import { LAMP_LAYOUT_SERVICE_MODE } from  "@/components/DrawCanvas/enums/index";
import { alerterror, alertsuccess } from '@/assets/js/common.js'

function downloadJSON(data, filename = 'data.json') {
  // 将数据转换为JSON字符串
  const jsonString = JSON.stringify(data, null, 2);
  
  // 创建Blob对象
  const blob = new Blob([jsonString], { type: 'application/json' });
  
  // 创建下载链接
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  // 设置链接属性
  link.href = url;
  link.download = filename;
  
  // 模拟点击下载
  document.body.appendChild(link);
  link.click();
  
  // 清理资源
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export default {
  methods: {
    async doFeiFan() {
      this.option = { light: 255 };
      await this.initRouteParams();
      this.requestFeifanInfo();
    },

    validateFileType(file) {
      const isJson = file.name.toLowerCase().endsWith('.json');
      const isJsonType = file.type === 'application/json' || 
                         file.type === 'text/json' ||
                         file.type === 'application/octet-stream';
      return isJson || isJsonType;
    },

    /**
     * 读取 JSON 文件内容
     * @param {File} file - 原始文件对象
     */
    readJsonFile(file) {
      if (!file) {
        this.$message.error(this.$t('projectmsg.fileNotExist'));
        return;
      }
      
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const content = e.target.result;
          const parsedData = JSON.parse(content);
          console.log('parsedData', parsedData);
          this.requestFeifanInfo({
            Result: [
              {
                Content: parsedData
              }
            ]
          });
          
          // this.$message.success('JSON 文件解析成功！');
          
          // 可以在这里触发自定义事件或调用回调函数
          // this.$emit('json-loaded', this.parsedData);
          
        } catch (error) {
          console.error('JSON parse error', error);
          this.$message.error(this.$t('projectmsg.jsonFormatError'));
          // this.parsedData = null;
        }
      };
      
      reader.onerror = () => {
        this.$message.error(this.$t('projectmsg.fileReadFailed'));
      };
      
      reader.readAsText(file);
    },

    handleFileChange(file, fileList) {
      if (!file) return;
      
      // 检查文件类型
      if (this.validateFileType(file)) {
        this.readJsonFile(file.raw);
      } else {
        this.$message.error(this.$t('projectmsg.uploadValidJson'));
      }
    },


    async requestFeifanInfo(Mark4Temp) {
      const params = this.$route.params;
      this.parameters.GpNo = params.GpNo;

      const deviceList = this.checkDeviceList;

      let Mark4Res = Mark4Temp;

      if (!Mark4Res) {
        Mark4Res = await GetCustomDataList({
          projectCode: this.$store.state.projectcode,
          type: 'PointSolution',
          identifier: deviceList[0].realVDeviceId
        });
      };
      
      const Mark4 = (Mark4Res?.Result[0] || [{}]).Content;
        let MarkRes = {};

        try {
          MarkRes = JSON.parse(Mark4);
          
        } catch (e) {

        }


        const { directionType, initData, appData } = MarkRes;

        
        if (!!MarkRes) {
          const option = MarkRes.option || { light: 255 };
          this.bgUrl = initData.bg.url;
          this.version = MarkRes.version || 0;
          this.imageMode = MarkRes.option?.imageMode === undefined ? 1 : MarkRes.option?.imageMode
          this.parameters.deviceText = MarkRes.option?.deviceText || '';
          this.parameters.shapeType = MarkRes.shapType;

          // 已经删除了的设备 线圈不要了
          const delDeviceIds = deviceList.filter(item => !!item.IsDel).map(item => item.VDeviceId);
          const modeData = initData.modeData;

          if (!!Mark4Temp) {
             Object.entries(modeData).forEach(([key, val]) => {
              const newKey = key.replace(/^.+-/,  `${deviceList[0].realVDeviceId}-`);

              modeData[newKey] = val;

              if (newKey !== key) {
                delete modeData[key];
              }
            });
          }
         
          for (let k in modeData) {
            if (delDeviceIds.includes(k)) delete modeData[k];

            const lampData = modeData[k];
            // 老版本数据 原本会忽略短边 现在不忽略 所以直接按补0
            if (
              this.version === 0 && 
              lampData.l && 
              lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && 
              lampData.l.l &&
              lampData.l.l.length > 1
            ) {
              lampData.l.l = lampData.l.l.join(',0,').split(',');
            }
          }
          
          this.canvasInitData = {
            ...initData,
            modeData
          };
          
          this.option = option;
      }
    },


    // handlerPutFeifanData() {
    //   const data = this.feifanshuju;

    //   const aa = JSON.parse(JSON.parse(data));
    //   debugger
    // },

    async getFeifanData() {
      // const isCanSubmit = this.verifyCanSave(false);

      // if (!isCanSubmit.status) {
      //   this.$message({
      //     type: 'warning',
      //     message: isCanSubmit.message
      //   });

      //   return;
      // }

      const Mark4 = this.getMark4();

      const feifanData = JSON.parse(Mark4);

      const data = feifanData.appData.position;

      const device = this.checkDeviceList[0];

      const resList = [];

      // let lastVDeviceId = null;

      let minX = 999999;
      let maxX = 0;
      let minY = 999999;
      let maxY = 0;

      data.forEach((item, i) => {
        const posData = item.posData;

        // if (lastVDeviceId !== item.vDeviceId) {
        //   deviceCount++;
        //   channelCount = 1;
        //   lastVDeviceId = item.vDeviceId;
        // } else {
        //   channelCount++;
        // }

        posData.forEach((pos, posIndex) => {
          if (pos.x < minX) {
            minX = pos.x;
          }

          if (pos.x > maxX) {
            maxX = pos.x;
          }

          if (pos.y < minY) {
            minY = pos.y;
          }

          if (pos.y > maxY) {
            maxY = pos.y;
          }

          

          resList.push({
            index: posIndex + 1,
            x: pos.x,
            y: pos.y,
            device: Math.floor(item.id / 2) + 1, // deviceCount,
            channel: (item.id % 2) + 1,// channelCount
          });
        });
      });

      const plusX = maxX - minX;
      const plusY = maxY - minY;
      let left = 0;
      let top = 0;

      let props = 0;

      if (plusY > plusX) {
        props = plusY;
        left = (plusY - plusX) / 2;

      } else {
        props = plusX;
        top = (plusX - plusY) / 2;
      }

      resList.forEach(item => {
        item.x = Number(((item.x - minX + left) / props).toFixed(6));
        item.y = Number(((item.y - minY + top) / props).toFixed(6));
      })

      await SaveOrUpdateCustomData([{
        ProjectCode: this.$store.state.projectcode,
        Type: 'PointSolution',
        Identifier: device.realVDeviceId,
        Content: Mark4
      }]);

      const params = {
        refreshBin: true,
        classSku: device.ClassSku,
        pointList: resList,
        vdeviceId:device.realVDeviceId,
      }
      
      downloadJSON(Mark4)

      try {
         const res = await saveFeifanPoint(params);

         if(res.StatusCode == this.$store.state.rightStatusCode){
            alertsuccess(this, res.StatusCode)
             this.$router.push({
              path: '/install'
            })
      
            return;
         }
         alerterror(this, res.StatusCode)
      } catch (error) {
        console.log(error);
      }
    }
  },
}